export { default } from './SkeletonHotelLowRateCalendarMobile';
